<template>
  <div>
    <!-- 提出新订单： -->

    <el-dialog :title="$t('message.addGoods')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1542px" center>
      <div class="addGoods">
        <!-- 订单类别 -->
        <div class="type">
          <!-- 订单类别 -->
          <span>{{ $t("message.orderType") }} :</span>
          <!-- 单选 -->
          <div class="radio">
            <el-radio-group v-model="type">
              <!-- 普通订单 -->
              <el-radio :label="item.key" v-for="(item, index) in typeList" :key="index">{{ item.value
              }}</el-radio>
            </el-radio-group>
          </div>

        </div>
        <div class="type">
          <!-- 客户ID： -->
          <span>{{ $t("message.userID") }} :</span>
          <div class="input">
            <el-input v-model="user_id" size="small" onfocus="this.select()" type="number" :disabled="isUser_id"
              @blur="clientList"></el-input>
          </div>
          <!-- 客户真名： -->
          <span>{{ $t("message.userName") }} :</span>
          <div>
            {{ realname }}
          </div>
        </div>
        <!-- 下单类型 -->
        <el-tabs v-model="orderType" type="card" @tab-click="handleClick">
          <!-- 手动下单 -->
          <el-tab-pane :label="$t('message.manualOrder')" name="1"></el-tab-pane>
          <!-- EXCEL下单 -->
          <el-tab-pane :label="$t('message.excelOrder')" name="2"></el-tab-pane>

        </el-tabs>
        <!-- 手动下单 -->
        <div v-if="orderType == '1'">
          <!-- 添加 -->
          <div class="add">
            <!--  跳过财务付款 -->
            <el-button type="primary" class="primary" size="small"
              @click="addSpecialShooting('https://www.rakumart.com/ProductDetails?goods_id=16885&fromPlatform=rakumart')">
              {{ $t('message.skipFinancialPayments') }}
            </el-button>
            <!--  OEM专拍 -->
            <el-button type="primary" size="small"
              @click="addSpecialShooting('https://www.rakumart.com/ProductDetails?goods_id=16827&fromPlatform=rakumart')">
              {{ $t('message.oemExclusiveShooting') }}
            </el-button>
            <el-button size="small" type="success" @click="add">{{
              $t("message.add")
            }}</el-button>
          </div>
          <div class="table">
            <ol>
              <li class="flex05">NO</li>
              <!-- 商品链接 -->
              <li class="flex2">
                {{ $t("message.ProductLink") }}
              </li>
              <!-- 图片 -->
              <li>{{ $t("message.pic") }}</li>
              <!-- 商品属性 -->
              <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
              <!-- 商品属性 -->
              <li class="flex15">{{ $t("message.businessEditAttributes") }}</li>
              <!-- 商品数量 -->
              <li>{{ $t("message.numberOfProducts") }}</li>
              <!-- 单价 -->
              <li>{{ $t("message.price") }}</li>
              <!-- 客户商品备注 -->
              <li class="flex15">{{ $t("message.customerProductRemarks") }}</li>
              <!-- 业务翻译 -->
              <li class="flex15">{{ $t("message.businessTranslation") }}</li>
              <!-- 操作 -->
              <li>{{ $t("message.operation") }}</li>
            </ol>
            <ul v-for="(item, index) in tableData" :key="index">
              <li class="flex05">{{ index + 1 }}</li>
              <!-- 商品链接 -->
              <li class="flex2">
                <el-input v-model="item.url" @blur="goodsParticulars(item.url, index)"
                  onfocus="this.select()"></el-input>
              </li>
              <!-- 图片 -->
              <li>
                <el-upload class="avatar-uploader" :action="baseURL + '/api/common/uploadFile'" :show-file-list="false"
                  :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                  <a href="javascript:;" @click="i = index">
                    <el-image :src="item.pic" style="width: 60px; height: 60px">
                      <div slot="placeholder" class="image-slot">
                        加载中<span class="dot">...</span>
                      </div>
                      <div slot="error" class="image-slot">
                      </div>
                    </el-image>
                  </a>
                </el-upload>
              </li>
              <!-- 商品属性 -->
              <li class="flex15">
                <div class="template" @click="editAttribute(item, index,)">
                  <el-tooltip placement="bottom">
                    <div slot="content">
                      <div class="row" v-for="(itemDetail, itemIndex) in item.detail" :key="itemIndex"
                        style="margin-bottom: 5px">
                        {{ itemDetail.key }}：{{ itemDetail.value }}
                      </div>
                    </div>
                    <div>
                      <div class="row" v-for="(itemDetail, itemIndex) in item.detail" :key="itemIndex">
                        {{ itemDetail.key }}：{{ itemDetail.value }}
                      </div>
                    </div>
                  </el-tooltip>
                </div>
              </li>
              <!-- 商品属性 -->
              <li class="flex15">
                <div class="template" @click="editAttribute(item, index,)">
                  <el-tooltip placement="bottom">
                    <div slot="content">
                      <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex"
                        style="margin-bottom: 5px">
                        {{ itemDetail.key }}：{{ itemDetail.value }}
                      </div>
                    </div>
                    <div>
                      <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex">
                        {{ itemDetail.key }}：{{ itemDetail.value }}
                      </div>
                    </div>
                  </el-tooltip>
                </div>
              </li>
              <!-- 商品数量 -->
              <li>
                <el-input v-model="item.num" onfocus="this.select()" type="number"></el-input>
              </li>
              <!-- 单价 -->
              <li>
                <el-input v-model="item.price" onfocus="this.select()" type="number"></el-input>
              </li>
              <!-- 商品备注 -->
              <li class="flex15">
                <el-input type="textarea" placeholder="请输入内容" v-model="item.client_remark" show-word-limit
                  onfocus="this.select()" @input="item.y_remark = item.client_remark"></el-input>
              </li>
              <!-- 业务翻译 -->
              <li class="flex15">
                <el-input type="textarea" placeholder="请输入内容" v-model="item.y_remark" show-word-limit
                  onfocus="this.select()"></el-input>
              </li>
              <!-- 操作 -->
              <li>
                <!-- 删除 -->
                <el-button size="mini" class="dark" type="primary" @click="delItem(index)">
                  {{ $t("message.delete") }}
                </el-button>
              </li>
            </ul>
          </div>
        </div>
        <!-- EXCEL下单 -->
        <div v-else>
          <div class="excelOrder">
            <!-- 上传 -->
            <el-upload class="upload-demo" drag :action="baseURL + '/order.excelOrder'" multiple :show-file-list="false"
              :data="{ user_id: user_id, type: type }" :headers="{
                AdminToken: 'Bearer ' + token
              }" :on-success="handleAvatarSuccessFile" :before-upload="beforeAvatarUploadFile">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
            <a :href="'https://apiwww.rakumart.com/client/excelOrder.excelOrderTpl?rand=' + rand" class="link">
              <el-button type="primary">EXCLE模板下载</el-button>
            </a>
            <i class="el-icon-tickets" v-if="goods != false"></i>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 立即下单 -->
        <el-button type="primary" @click="save" v-if="orderType == '1'">{{
          $t("message.orderNow")
        }}</el-button>
        <!-- EXCEL下单 -->
        <el-button type="primary" @click="saveExcel" v-else>{{
          $t("message.orderNow")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 修改属性 -->
    <el-dialog :title="$t('message.propertyEditForm')" :close-on-click-modal="false"
      :visible.sync="attributeDialogVisible" width="1400px" center>

      <div class="content">
        <!-- 商品属性 -->
        <div class="item">
          <div class="title">{{ $t("message.commodityAttribute") }}</div>
          <editAttribute ref="detailRef" />
        </div>
        <!-- 业务商品属性 -->
        <div class="item">
          <div class="title">{{ $t("message.businessEditAttributes") }}</div>
          <editAttribute ref="detail_yRef" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="attributeDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="saveAttribute">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import editAttribute from "@/components/common/editAttribute.vue";

export default {
  props: {
    isUser_id: { type: Boolean },
  },
  components: { editAttribute, },
  data() {
    return {
      token: this.$store.state.token,
      orderType: "1",
      user_id: '',
      type: "",
      // EXCEL下单文件
      file: '',
      token: localStorage.getItem('japan_access_token'),
      goods: [],
      order_sn: '',
      rand: '',
      tableData: [
        {
          sku_id: "",
          spec_id: "",
          detail: [],
          detail_y: [],
          goods_id: "",
          mi_id: "",
          goods_title: "",
          num: "",
          price: "",
          pic: "",
          shop_id: "",
          shop_name: "",
          from_platform: "",
          y_remark: "",
          client_remark: "",
          url: "",
          sorting: 1,
        },
      ],
      realname: '',
      attributeDialogVisible: false,
      dialogVisible: false,
      goodsInventory: [],
      i: 0,
    };
  },
  computed: {
    typeList() {
      return this.$store.state.typeList;
    },
  },
  methods: {
    clientList() {
      if (!this.user_id) return
      this.$api.clienteleApi.clientList({ id: this.user_id }).then((res) => {
        this.realname = res.data.data[0].realname;

      });
    },
    goodsParticulars(url, i) {
      //   var reg = RegExp(/1688|taobao|tmall|m.tb.cn/);
      //   let regtaobao = RegExp(/taobao/);
      //   let reg1688 = RegExp(/1688/);
      //   let regtmall = RegExp(/tmall/);
      //   let mtb = RegExp(/m.tb.cn/);
      //   let type = "";
      //   var reg1 = /1688.com\/offer\/([0-9]+)/;
      //   var reg4 = /m\.1688\.com.*offerId=([0-9]{10,})/; //1688手机
      //   var reg2 = /[?|&]id=(\d{10,15})/;
      //   var reg3 = /detail.tmall.com.*&id=([0-9]+)/;
      //   let id = "";
      //   if (!reg.test(url)) {
      //     return this.$message.error("无效链接，请输入1688，天猫，淘宝商品链接");
      //   }
      //   // 判断是哪个网站的商品链接
      //   if (regtaobao.test(url)) {
      //     type = "taobao";
      //     id = url.match(reg2)[1];
      //   } else if (reg1688.test(url)) {
      //     type = "1688";
      //     if (url.match(reg1) == null) {
      //       id = url.match(reg4)[1];
      //     } else {
      //       id = url.match(reg1)[1];
      //     }
      //   } else if (regtmall.test(url)) {
      //     type = "tmall";
      //     id = url.match(reg2)[1];
      //   }

      this.$api.goodsUrlToGoodsId({ goods_url: url }).then(res => {
        const miId = res.data.mi_id || ''
        let timestamp = Math.floor(new Date().valueOf() / 1000)
        let sign = 'wakanda forever!@9523`'
        let datas = {
          shop_type: res.data.from_platform,
          goods_id: res.data.goods_id,
          mi_id: miId,
          timestamp,
          sign: this.$md5(`${sign}${timestamp}${sign}`)
        };
        this.$api.orderApi.goodsParticulars(datas).then((res) => {

          let data = res.data;
          this.goodsInventory = res.data.goodsInfo.goodsInventory;
          let detail_y = []
          res.data.goodsInfo.specification.forEach(item => {
            detail_y.push({
              key: item.keyC,
              value: item.valueC[0].name,
            })
          })
          this.i = i;
          this.tableData[i].goods_id = data.goodsId;
          this.tableData[i].mi_id = data.mi_id || data.miId || miId;
          this.tableData[i].goods_title = data.titleC;
          this.tableData[i].shop_id = data.shopId;
          this.tableData[i].shop_name = data.shopName;
          this.tableData[i].from_platform = data.fromPlatform;
          this.tableData[i].pic = data.images[0];
          this.tableData[i].show = true;
          this.tableData[i].detail = detail_y;
          this.tableData[i].detail_y = detail_y;
          this.tableData[i].goodsInventory = data.goodsInfo.goodsInventory

          this.receiveAttributeEdit(detail_y, '')
          this.$forceUpdate();
          // console.log(this.tableData[i]);
        });
      })

    },
    // 新增
    add() {
      this.tableData.push({
        sku_id: "",
        spec_id: "",
        sku_id_y: '',
        spec_id_y: '',
        detail: [],
        goods_id: "",
        mi_id: "",
        goods_title: "",
        num: "",
        price: "",
        pic: "",
        shop_id: "",
        shop_name: "",
        from_platform: "",
        y_remark: "",
        url: "",
        sorting: this.tableData.length + 1
      });
    },
    // 新增专拍
    addSpecialShooting(url) {
      this.tableData.push({
        sku_id: "",
        spec_id: "",
        detail: [],
        goods_id: "",
        mi_id: "",
        goods_title: "",
        num: "",
        price: "",
        pic: "",
        shop_id: "",
        shop_name: "",
        from_platform: "",
        y_remark: "",
        url,
        sorting: this.tableData.length + 1
      });
      this.goodsParticulars(url, this.tableData.length - 1)
    },
    // 删除
    delItem(i) {
      this.tableData.splice(i, 1);
    },
    // 修改属性
    editAttribute(item, i,) {
      this.i = i;
      this.goodsInventory = item.goodsInventory
      if (item.show) {
        let timestamp = Math.floor(new Date().valueOf() / 1000)
        let sign = 'wakanda forever!@9523`'
        let datas = {
          shop_type: item.from_platform,
          goods_id: item.goods_id,
          mi_id: item.mi_id || '',
          timestamp,
          sign: this.$md5(`${sign}${timestamp}${sign}`)
        };
        this.$api.orderApi.goodsParticulars(datas).then((res) => {
          let detail = {
            detail: item.detail,
            sorting: item.sorting,
            from_platform: item.from_platform,
            type: 'detail'
          }
          let detail_y = {
            detail: item.detail_y,
            sorting: item.sorting,
            from_platform: item.from_platform,
            type: 'detail_y'
          }
          this.attributeDialogVisible = true;
          this.$nextTick(() => {
            console.log(this.$refs.detailRef);
            this.$refs.detailRef.goodsParticulars(JSON.parse(JSON.stringify(res)), detail)
            this.$refs.detail_yRef.goodsParticulars(JSON.parse(JSON.stringify(res)), detail_y)
          })
        });
      }
    },
    // 保存属性
    saveAttribute() {
      this.$refs.detailRef.save()
      this.$refs.detail_yRef.save()
    },
    // 接收修改属性
    receiveAttributeEdit(data, pic, type) {
      if (type == 'detail') {
        this.tableData[this.i].detail = data;
      } else {
        this.tableData[this.i].detail_y = data;
      }
      if (pic) {
        this.tableData[this.i].pic = pic;
      }
      this.searchPricr(data, type);
      this.attributeDialogVisible = false;
    },
    // 查找价格
    searchPricr(data, type) {
      let str = "";
      data.forEach((item) => {
        str += item.value + "㊖㊎";
      });
      str = str.substr(0, str.length - 2);
      for (let i = 0; i < this.goodsInventory.length; i++) {
        if (this.goodsInventory[i].keyC == str) {

          this.tableData[this.i].price = this.goodsInventory[i].valueC[0].price;
          if (type == 'detail') {
            this.tableData[this.i].sku_id =
              this.goodsInventory[i].valueC[0].skuId;
            this.tableData[this.i].spec_id =
              this.goodsInventory[i].valueC[0].specId;
          } else if (type == 'detail_y') {
            this.tableData[this.i].sku_id_y =
              this.goodsInventory[i].valueC[0].skuId;
            this.tableData[this.i].spec_id_y =
              this.goodsInventory[i].valueC[0].specId;
          } else {
            this.tableData[this.i].sku_id =
              this.goodsInventory[i].valueC[0].skuId;
            this.tableData[this.i].spec_id =
              this.goodsInventory[i].valueC[0].specId;
            this.tableData[this.i].sku_id_y =
              this.goodsInventory[i].valueC[0].skuId;
            this.tableData[this.i].spec_id_y =
              this.goodsInventory[i].valueC[0].specId;
          }

          this.tableData[this.i].num =
            this.goodsInventory[i].valueC[0].startQuantity;
          break;
        } else {
          this.tableData[this.i].price = "";
          if (type == 'detail') {
            this.tableData[this.i].sku_id = "";
            this.tableData[this.i].spec_id = "";
          } else if (type == 'detail_y') {
            this.tableData[this.i].sku_id_y = "";
            this.tableData[this.i].spec_id_y = "";
          }
        }
      }
      this.$forceUpdate();
    },
    //保存
    save() {
      let datas = {
        type: this.type,
        user_id: this.user_id,
        relation_order_sn: this.$route.query.order_sn,
        order_detail: this.tableData,
      };
      console.log(this.tableData);

      this.$api.orderApi
        .manageCreateOrder({ data: JSON.stringify(datas) })
        .then((res) => {
          this.$message.success(res.msg);
          this.dialogVisible = false;
          this.user_id = "";
          this.type = "";
          this.tableData = [
            {
              sku_id: "",
              spec_id: "",
              detail: [],
              goods_id: "",
              mi_id: "",
              goods_title: "",
              num: "",
              price: "",
              pic: "",
              shop_id: "",
              shop_name: "",
              from_platform: "",
              y_remark: "",
              url: "",
            },
          ];
          if (this.$route.name == 'orderTranslate') {
            this.$parent.orderList()
          }
        });
    },
    // 上传成功
    handleAvatarSuccess(res) {
      this.tableData[this.i].pic = res.data;
      this.$message.success(res.msg)
      this.loading = false;
    },
    // 上传前
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSVG = file.type === "image/svg+xml";

      this.loading = true;
      if (!isJPG && !isPNG && !isSVG) {
        this.$message.error("上传图片只能是 JPG,PNG 格式,SVG格式!");
        this.loading = false;
      }
      return isJPG || isPNG || isSVG;
    },
    //重置信息
    setData(id, realname) {
      this.tableData = [
        {
          sku_id: "",
          spec_id: "",
          sku_id_y: "",
          spec_id_y: "",
          detail: [],
          detail_y: [],
          goods_id: "",
          mi_id: "",
          goods_title: "",
          num: "",
          price: "",
          pic: "",
          shop_id: "",
          shop_name: "",
          from_platform: "",
          y_remark: "",
          url: "",
          sorting: 1,
        },
      ]
      this.realname = realname
      this.user_id = id
      this.type = ''
    },
    // 下单类型点击
    handleClick() {
      for (var i = 0; i < 6; i++) {
        this.rand += Math.floor(Math.random() * 10);
      }
    },
    // EXCEL下单
    //上传成功
    handleAvatarSuccessFile(res) {
      if (res.code != 0) return this.$message.error(res.msg)
      this.$message.success(res.msg)

      this.goods = []
      this.order_sn = res.data.order_sn
      res.data.order_data.forEach(item => {
        item.goods.forEach(items => {
          this.goods.push({
            No: 1,
            detail: items.detail,
            detail_y: [],
            from_platform: items.from_platform,
            goodsId: items.goods_id,
            mi_id: items.mi_id || '',
            goods_title: items.goods_title,
            link: "",
            num: items.num,
            pic: items.pic,
            service_rate: 0,
            shop_id: items.shop_id,
            shop_name: items.shop_name,
            show: true,
            price: items.price,
            order_detail_tag: items.order_detail_tag,
            client_remark: items.client_remark,
            for_sn: items.for_sn,
          })
        })
      })
    },
    // 保存到预览
    saveExcel() {
      if (this.goods == false) return this.$message.error('请上传xlsx文件')
      if (this.user_id == '') return this.$message.error('客户ID缺失')
      this.$parent.excelOrderDialogVisible = false
      let routeUrl = this.$router.resolve({
        path: "/orderPreview?userID=" + this.user_id + "&type=excel" + '&order_sn=' + this.order_sn,
      });
      let data = {
        orderList: this.goods,
        y_reply: '',
        y_remark: '',
      }
      window.open(routeUrl.href, JSON.stringify(data));
    },
    // 格式格式
    beforeAvatarUploadFile(file) {
      const fileName = file.name || "";
      const excelMimeTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ];
      const excelSuffix = /\.(xlsx|xls)$/i.test(fileName);
      const isExcel = excelMimeTypes.includes(file.type) || excelSuffix;
      if (!isExcel) {
        this.$message.error("只能上传.xlsx或.xls文件");
      }

      return isExcel;
    },

  },

};
</script>
<style lang='scss' scoped>
.addGoods {
  padding: 24px;
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;

  .type {
    display: flex;
    flex-wrap: wrap;
    line-height: 32px;
    margin-bottom: 24px;
    // position: relative;

    .btn {
      // position: absolute;
      // top: 0px;
      // right: 60px
      margin-left: 100px;
    }

    &:nth-child(1) {
      margin-top: 0;
    }

    .radio {
      margin-right: 80px;
    }

    span {
      margin-right: 20px;
    }

    .input {
      width: 100px;
      margin-right: 24px;
    }
  }

  .add {
    margin-bottom: 15px;
    text-align: right;
  }

  .table {
    ol {
      display: flex;
      height: 40px;
      background: #edeff4;
      border-radius: 4px 4px 0px 0px;
      justify-content: center;
      align-items: center;

      li {
        height: 40px;
        text-align: center;
      }
    }

    ul {
      display: flex;
      padding: 10px 0;
      border-bottom: 1px solid #edeff4;

      /deep/.el-upload-dragger {
        width: 60px;
        height: 60px
      }
    }

    li {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 5px;

      &:nth-last-child(1) {
        margin-right: 0;
      }
    }

    .flex2 {
      flex: 3;
    }

    .flex05 {
      flex: 0.5;
    }

    .flex15 {
      flex: 1.8;
    }

    .template {
      width: 100%;
      padding: 10px;
      background-color: #fff;
      height: 80px;
      overflow: hidden;
      cursor: pointer;
    }
  }
}

/deep/.el-textarea__inner {
  padding: 5px;
  min-height: 63px !important;
  height: 100px !important;
}

/deep/.is-disabled {
  .el-input__inner {
    background-color: #fff;
    color: #606266;
  }
}

.content {
  display: flex;

  .item {
    flex: 1;

    &:nth-last-child(1) {
      margin-left: 50px;
    }
  }
}

.excelOrder {
  display: flex;

  position: relative;

  .link {
    position: absolute;
    bottom: 0;
    right: 0;
  }

  .el-icon-tickets {
    font-size: 180px;
    margin-left: 20px;
  }
}
</style>
